import React, { useCallback, useContext } from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DEFAULT_DATA_ORIGIN } from '../../constants/constants';
import { CompanyContext } from '../../context/company/companyContext';
import { IUserHolding } from '../../interfaces/businessData';
import { TRANSLATIONS_GLOBAL } from '../../translations/commons';
import DropdownButton from '../DropdownButton/DropdownButton';
import { IMenuPosition } from '../StyledMenu/StyledMenu';

import './styles.scss';

interface HoldingSelectorProps {
  menuDirection: {
    anchor: IMenuPosition;
    transform: IMenuPosition;
  };
}

const HoldingSelector = ({ menuDirection }: HoldingSelectorProps) => {
  const { holding, holdingList, setUserHolding, setUserDataOrigin } = useContext(CompanyContext);

  const { t } = useTranslation();

  const handleHoldingMenu = useCallback(
    (holdingData: IUserHolding) => {
      setUserHolding(holdingData);
      setUserDataOrigin(DEFAULT_DATA_ORIGIN);
    },
    [setUserHolding, setUserDataOrigin]
  );

  return holdingList.length > 0 ? (
    <div className={holdingList.length == 1 ? 'holding-button single-holding' : 'holding-button'}>
      <div className="holding-text">{`${t(TRANSLATIONS_GLOBAL.selector.holding)}:`}</div>
      <DropdownButton
        disabled={holdingList.length == 1}
        currentItem={holding}
        itemList={holdingList}
        setCurrentItem={handleHoldingMenu}
        menuDirection={menuDirection}
      />
    </div>
  ) : (
    <div className="holding-button">
      <Skeleton animation="wave" variant="text" width={200}></Skeleton>
    </div>
  );
};

export default HoldingSelector;
